import { PATH } from '@repo/constants';
import { RouterSuspense } from '@ui/components';
import React, { FC } from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
  isAllowed: boolean;
}

export const ProtectedRoute: FC<ProtectedRouteProps> = (props) => {
  const { children, isAllowed } = props;

  if (!isAllowed) {
    return <Navigate to={PATH.DASHBOARD} />;
  }
  return <RouterSuspense>{children}</RouterSuspense>;
};
